import { ReactElement, cloneElement, useState } from "react";
import { ClickAwayListener, Tooltip } from "@mui/material";

/** Attach help to the input itself without introducing another tab stop. */
export default function CustomFieldTooltip({
  text,
  children,
}: {
  text?: string;
  children: ReactElement;
}) {
  const [open, setOpen] = useState(false);
  const [id] = useState(() => `custom-field-help-${crypto.randomUUID()}`);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        id={id}
        title={text || ""}
        describeChild
        open={!!text && open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableTouchListener
      >
        <div
          style={{ display: "flex", flex: "1 1 0", minWidth: 0 }}
          onFocus={() => setOpen(true)}
          onBlur={() => setOpen(false)}
          onClick={() => setOpen(true)}
          onKeyDown={(e) => {
            if (e.key === "Escape") setOpen(false);
          }}
        >
          {cloneElement(children, {
            inputProps: {
              ...children.props.inputProps,
              "aria-describedby":
                [children.props.inputProps?.["aria-describedby"], open && text ? id : null]
                  .filter(Boolean)
                  .join(" ") || undefined,
            },
          })}
        </div>
      </Tooltip>
    </ClickAwayListener>
  );
}
